import { CLIENTS_CATEGORIES } from '@/entities/clients-categories';
import type { ClientsListType } from '@/entities/clients-filter.entity';
import { cn } from '@/lib/utils';

interface CategoryTabsProps {
	value: ClientsListType;
	onChange: (value: ClientsListType) => void;
}

export default function CategoryTabs({ value, onChange }: CategoryTabsProps) {
	return (
		<div className='overflow-x-auto scrollbar-hide -mx-0.5 px-0.5'>
			<div className='flex gap-1.5 w-max min-w-full'>
				{CLIENTS_CATEGORIES.map(cat => {
					const Icon = cat.icon;
					const active = value === cat.id;
					return (
						<button
							key={cat.id}
							type='button'
							onClick={() => onChange(cat.id)}
							className={cn(
								'shrink-0 h-8 px-3 rounded-md text-sm inline-flex items-center gap-1.5 border transition-colors',
								active ? 'bg-secondary border-border text-foreground font-medium' : 'bg-transparent border-transparent text-muted-foreground',
							)}
						>
							<Icon size={15} className={cn(active && 'text-chart-2')} />
							{cat.label}
							{!cat.ready && <span className='text-[10px] opacity-50'>soon</span>}
						</button>
					);
				})}
			</div>
		</div>
	);
}
